<div
  class="ui-switch"
  [class.ui-switch--checked]="checked()"
  [class.ui-switch--disabled]="disabled()"
  [class.ui-switch--invalid]="invalid()"
>
  <label class="ui-switch__row" [attr.for]="inputId()">
    <!-- Input nativo sr-only -->
    <input
      class="ui-switch__input"
      type="checkbox"
      role="switch"
      [id]="inputId()"
      [attr.name]="name() ?? null"
      [checked]="checked()"
      [disabled]="disabled()"
      [attr.aria-checked]="checked()"
      [attr.aria-required]="required() ? 'true' : null"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-describedby]="ariaDescribedBy()"
      (change)="onChange($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    />

    <!-- Track + thumb (siempre en el DOM, CSS controla el estado) -->
    <span class="ui-switch__track" aria-hidden="true">
      <span class="ui-switch__thumb"></span>
    </span>

    <!-- Label + descripción -->
    @if (label() || description()) {
      <span class="ui-switch__content">
        @if (label()) {
          <span class="ui-switch__label">
            {{ label() }}
            @if (showRequirement()) {
              <span
                class="ui-switch__requirement"
                [class.ui-switch__requirement--error]="invalid() && required()"
                aria-hidden="true"
              >
                {{ requirementText() }}
              </span>
            }
          </span>
        }
        @if (description()) {
          <span class="ui-switch__description" [id]="inputId() + '-desc'">
            {{ description() }}
          </span>
        }
      </span>
    }
  </label>

  @if (message() && invalid() && showMessage()) {
    <p class="ui-switch__message" [id]="messageId()" role="alert">
      {{ message() }}
    </p>
  }
</div>
